import { render, staticRenderFns } from "./Avatars.vue?vue&type=template&id=2bc48a83&scoped=true&"
import script from "./Avatars.vue?vue&type=script&lang=js&"
export * from "./Avatars.vue?vue&type=script&lang=js&"
import style0 from "./Avatars.vue?vue&type=style&index=0&id=2bc48a83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc48a83",
  null
  
)

export default component.exports